module.exports = __webpack_public_path__ + "img/forward.be5030ca.webp";